module.exports = __webpack_public_path__ + "img/pinBk.24d2c2d5.png";